<template>
  <div>
    <v-toolbar color="info" dark class="elevation-0">
      <v-toolbar-title>
        <div class="text-xs-center">Search For Block Phone Number</div>
      </v-toolbar-title>
    </v-toolbar>
    <v-container grid-list-lg>
      <v-layout column align-center class="mt-5">
        <v-flex>
          <span>Phone Number</span>
        </v-flex>
        <v-flex>
          <v-text-field @keyup.enter="getNumber()" v-model="phoneNumber" solo hide-details></v-text-field>
        </v-flex>
        <v-flex>
          <v-btn :disabled="!phoneNumber.length" color="info" @click="getNumber()">Search</v-btn>
          <v-btn color="red" v-if="nodata" @click="addToBlackList()" dark>BlackList</v-btn>
        </v-flex>
        <v-flex>
          <v-card class="mt-3" v-if="numberData" max-width="500">
            <v-card-text v-if="loading">
              <div class="text-xs-center">
              <v-progress-circular size="70" width="7" color="purple" indeterminate></v-progress-circular>
              </div>
            </v-card-text>
            <v-card-text v-else>
              <v-layout column align-center>
                <v-card :color="color" dark class="mb-2">
                  <v-card-text>
                    Status:
                    <span
                      class="font-weight-bold text-capitalize"
                    >{{ numberData.status }}</span>
                  </v-card-text>
                </v-card>
                <v-flex class="pa-0">
                  ID:
                  <span class="font-weight-bold">{{ numberData.promotion_Id }}</span>
                </v-flex>
                <v-flex class="pa-0">
                  Created At:
                  <span
                    class="font-weight-bold"
                  >{{ numberData.createdAt | moment("from", "now") }}</span>
                </v-flex>
                <v-flex class="pa-0">
                  Sent At:
                  <span
                    class="font-weight-bold"
                  >{{ numberData.sentAt | moment("from", "now") }}</span>
                </v-flex>
                <v-flex class="pa-0">
                  Sent To:
                  <span class="font-weight-bold">{{ numberData.toNumber }}</span>
                </v-flex>
                <v-flex class="pa-0">
                  Sent From:
                  <span class="font-weight-bold">{{ numberData.fromNumber }}</span>
                </v-flex>

                <v-flex class="pa-0">
                  Message:
                  <span class="font-weight-bold">{{ numberData.Promotion.message }}</span>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
          <v-card v-if="nodata" color="green" dark>
            <v-card-text>
              <div class="text-xs-center">
                <h1>Good to Go!</h1>
              </div>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import promotionService from "./service.js";
export default {
  name: "product",
  data() {
    return {
      phoneNumber: "",
      numberData: null,
      loading: true,
      nodata: false,
    };
  },
  computed: {
    color(val) {
      let color = 'green'
      if (this.numberData.status === 'blacklist') color = 'red'
      if (this.numberData.status === 'undelivered') color = 'red'
      if (this.numberData.status === 'failed') color = 'red'
      return color
    }
  },
  methods: {
    getNumber() {
      this.nodata = false
      this.loading = true
      return promotionService
        .getByNumber({ toNumber: this.phoneNumber })
        .then(result => {
          console.log("ddfdfdfdf", result);
          this.numberData = result.data;
          if (!result.data) {
            this.nodata = true
          }
          this.loading = false
        });
    },
    addToBlackList() {
      this.$swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, Add to Black List !',
      }).then((result) => {
        if (result.value) {
          this.nodata = false
          this.loading = true 
          return promotionService
          .addToBlackList({ toNumber: this.phoneNumber })
          .then(result => {
            console.log('add to black list response ', result.data)
            this.numberData = result.data;
            if (!result.data) {
              this.nodata = true
            }
            this.loading = false
          })
          .catch((error) => {
            this.$toasted.error(error.data.message, {
              position: 'top-right',
              showHideTransition: 'slide',
              icon: 'error',
              duration: 5000,
            })
          })
        }
      })
    }
  }
};
</script>
